import { render } from "./ContextCapture.vue?vue&type=template&id=d2736f30&scoped=true"
import script from "./ContextCapture.vue?vue&type=script&lang=js"
export * from "./ContextCapture.vue?vue&type=script&lang=js"

import "./ContextCapture.vue?vue&type=style&index=0&id=d2736f30&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d2736f30"]])

export default __exports__